const _TemplatesGroupedByTheme =
{
	/* EDIT THEME - Interactive mode for browsers */
	Edit: [
		{
			HashPostfix: '-Template-Input-InputType-Chart',
			DefaultInputExtensions: [ 'Pict-Input-Chart' ],
			Template: /*HTML*/`
			<!-- InputType Chart {~D:Record.Hash~} {~D:Record.DataType~} -->
			<div class="pict-input-chart" style="width:{~DWAF:Record.PictForm.QuantizedWidth:100~}%; margin-left:{~DWAF:Record.PictForm.QuantizedWidthOffset:0~}%; display:inline-block; padding: 0.75rem;">
				<input type="hidden" id="CONFIG-FOR-{~D:Record.Macro.RawHTMLID~}" value="">
				<label {~D:Record.Macro.HTMLForID~} class="label {~HideLabel:Record~} {~LabelAlignment:Record~}">{~LabelWithChips:Record~}</label>
				<!-- ChartHeight (pixels) sets the plot area; min-height so the default of 0
				     is a no-op and Chart.js keeps its own 2:1 sizing. Must match the base
				     template in pict-section-form -- these themed copies OVERRIDE it. -->
				<div style="width:100%; min-height:{~DWAF:Record.PictForm.ChartHeight:0~}px;">
					<canvas {~D:Record.Macro.ControlAttr~} id="CANVAS-FOR-{~D:Record.Macro.RawHTMLID~}" {~D:Record.Macro.InputFullProperties~}></canvas>
				</div>
				<p class="help"><span class="description-text">{~D:Record.Description~}</span></p>
			</div>`,
		},
	],
	/* READ THEME - Interactive mode for browsers in a locked/disabled/readonly state */
	Read: [
		{
			HashPostfix: '-Template-Input-InputType-Chart',
			DefaultInputExtensions: [ 'Pict-Input-Chart' ],
			Template: /*HTML*/`
			<!-- InputType Chart {~D:Record.Hash~} {~D:Record.DataType~} -->
			<div class="pict-input-chart" style="width:{~DWAF:Record.PictForm.QuantizedWidth:100~}%; margin-left:{~DWAF:Record.PictForm.QuantizedWidthOffset:0~}%; display:inline-block; padding: 0.75rem;">
				<input type="hidden" id="CONFIG-FOR-{~D:Record.Macro.RawHTMLID~}" value="">
				<label {~D:Record.Macro.HTMLForID~} class="label {~HideLabel:Record~} {~LabelAlignment:Record~}">{~LabelWithChips:Record~}</label>
				<!-- ChartHeight (pixels) sets the plot area; min-height so the default of 0
				     is a no-op and Chart.js keeps its own 2:1 sizing. Must match the base
				     template in pict-section-form -- these themed copies OVERRIDE it. -->
				<div style="width:100%; min-height:{~DWAF:Record.PictForm.ChartHeight:0~}px;">
					<canvas {~D:Record.Macro.ControlAttr~} id="CANVAS-FOR-{~D:Record.Macro.RawHTMLID~}" {~D:Record.Macro.InputFullProperties~}></canvas>
				</div>
			</div>`,
		},
	],
	/* PRINT THEME - Non-interactive mode for PDF documents */
	Print: [
		{
			HashPostfix: '-Template-Input-InputType-Chart',
			DefaultInputExtensions: [ 'Pict-Input-Chart' ],
			Template: /*HTML*/`
			<!-- InputType Chart {~D:Record.Hash~} {~D:Record.DataType~} -->
			<div class="pict-input-chart" style="width:{~DWAF:Record.PictForm.QuantizedWidth:100~}%; margin-left:{~DWAF:Record.PictForm.QuantizedWidthOffset:0~}%; display:inline-block; padding: 0.75rem;">
				<input type="hidden" id="CONFIG-FOR-{~D:Record.Macro.RawHTMLID~}" value="">
				<label {~D:Record.Macro.HTMLForID~} class="label {~HideLabel:Record~} {~LabelAlignment:Record~}">{~LabelWithChips:Record~}</label>
				<!-- ChartHeight (pixels) sets the plot area; min-height so the default of 0
				     is a no-op and Chart.js keeps its own 2:1 sizing. Must match the base
				     template in pict-section-form -- these themed copies OVERRIDE it. -->
				<div style="width:100%; min-height:{~DWAF:Record.PictForm.ChartHeight:0~}px;">
					<canvas {~D:Record.Macro.ControlAttr~} id="CANVAS-FOR-{~D:Record.Macro.RawHTMLID~}" {~D:Record.Macro.InputFullProperties~}></canvas>
				</div>
			</div>`,
		},
	],
};

module.exports = _TemplatesGroupedByTheme;
